import styled from 'react-emotion'
import LayoutContainer from './LayoutContainer'

const HeroContent = styled(LayoutContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

export default HeroContent
